import { Box, Code } from '@chakra-ui/react';

import Text from 'components/Text';

import PackagesPanel from '../../PackagesPanel';
import { IEditorPackage } from '../../types';

interface IPackagesTabProps {
  packages: IEditorPackage[];
  onPackagesChange?: (packages: IEditorPackage[]) => void;
}

const PackagesTab = ({ packages, onPackagesChange }: IPackagesTabProps) => {
  const handlePackagesChange = (newPackages: IEditorPackage[]) => {
    onPackagesChange?.(newPackages);
  };

  return (
    <Box>
      {/* Header */}
      <Box mb={4}>
        <Text fontSize="large" fontWeight="semibold" mb={2}>
          npm Packages
        </Text>
        <Text fontSize="small" opacity="secondary">
          Search and add npm packages to use in your code via ES modules.
        </Text>
      </Box>

      {/* Package manager */}
      <PackagesPanel packages={packages} onPackagesChange={handlePackagesChange} />

      {/* How to use */}
      <Box mt={6} p={3} bg="whiteAlpha.100" borderRadius="md">
        <Text fontSize="small" fontWeight="semibold" mb={2}>
          How to use packages
        </Text>
        <Text fontSize="micro" opacity="secondary" mb={2}>
          Import packages in your JavaScript using ES module syntax:
        </Text>
        <Box
          p={2}
          bg="blackAlpha.400"
          borderRadius="sm"
          fontFamily="mono"
          fontSize="micro"
        >
          <Code bg="transparent" color="purple.300" fontSize="micro">
            {`import { format } from 'date-fns';`}
          </Code>
        </Box>
        <Text fontSize="micro" opacity="secondary" mt={2}>
          Packages are loaded from CDN (esm.sh) and available immediately in your code.
        </Text>
      </Box>
    </Box>
  );
};

export default PackagesTab;
